/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonskindshare3Inputs */

const en_listingbuttonskindshare3 = /** @type {(inputs: Listingbuttonskindshare3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Share`)
};

const de_listingbuttonskindshare3 = /** @type {(inputs: Listingbuttonskindshare3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilen`)
};

/**
* | output |
* | --- |
* | "Share" |
*
* @param {Listingbuttonskindshare3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonskindshare3 = /** @type {((inputs?: Listingbuttonskindshare3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonskindshare3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonskindshare3(inputs)
	return de_listingbuttonskindshare3(inputs)
});
export { listingbuttonskindshare3 as "listingButtonsKindShare" }